export const AUTH_LOGIN_METHOD_STORAGE_KEY = 'chattenger:web:auth:login-method';
export const AUTH_OTP_SMS_FALLBACK_SECONDS = 60;
export const AUTH_EMAIL_OTP_CODE_LENGTH = 4;
